<div class="p-2 md:p-4">
  <div class="flex align-items-center justify-content-center mb-4">
    <div class="flex align-items-center">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center border-circle"
          [ngClass]="{
            'bg-primary text-white': currentStep >= 1,
            'border-primary text-primary': currentStep < 1
          }"
          style="width: 32px; height: 32px; border: 2px solid"
        >
          <span class="font-semibold">1</span>
        </div>
        <span
          class="ml-2 font-medium"
          [ngClass]="{ 'text-primary': currentStep >= 1 }"
          >Dane podstawowe</span
        >
      </div>

      <div
        class="mx-3"
        style="width: 60px; height: 2px; background-color: #e2e8f0"
        [ngClass]="{ 'bg-primary': currentStep >= 2 }"
      ></div>

      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center border-circle"
          [ngClass]="{
            'bg-primary text-white': currentStep >= 2,
            'border-primary text-primary': currentStep < 2
          }"
          style="width: 32px; height: 32px; border: 2px solid"
        >
          <span class="font-semibold">2</span>
        </div>
        <span
          class="ml-2 font-medium"
          [ngClass]="{ 'text-primary': currentStep >= 2 }"
          >Pliki multimedialne</span
        >
      </div>
    </div>
  </div>

  <div
    *ngIf="loading"
    class="flex justify-content-center align-items-center p-4"
  >
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>

  <div *ngIf="currentStep === 1 && !loading">
    <form [formGroup]="questionForm">
      <div
        class="form-decorator top-decorator flex w-full justify-content-left align-items-center mt-4"
      >
        <div class="title">Numer pytania</div>
        <input
          id="questionNumber"
          type="text"
          pInputText
          formControlName="questionNumber"
          placeholder="1"
          [ngClass]="{
            'ng-invalid ng-dirty': isFieldInvalid('questionNumber')
          }"
        />
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Rodzaj pytania</div>
        <p-dropdown
          id="questionCategoryGuid"
          formControlName="questionCategoryGuid"
          [options]="questionCategories"
          optionLabel="questionCategoryName"
          optionValue="guid"
          placeholder="Wybierz rodzaj pytania"
          [appendTo]="'body'"
          styleClass="w-full"
          class="w-full"
          [ngClass]="{
            'ng-invalid ng-dirty': isFieldInvalid('questionCategoryGuid')
          }"
        >
          <ng-template let-q pTemplate="selectedItem">
            <span class="ellipsis">{{ q.questionCategoryName | slice:0:100 }}</span>
          </ng-template>

          <ng-template let-q pTemplate="item">
            <span class="ellipsis">{{ q.questionCategoryName | slice:0:100 }}</span>
          </ng-template>
        </p-dropdown>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Kategorie</div>
        <p-multiSelect
          id="category"
          formControlName="category"
          [options]="availableExams"
          optionLabel="examName"
          placeholder="A, B, C, C1"
          appendTo="body"
          panelStyleClass="max-w-30rem"
          styleClass="custom-multiselect w-full"
          class="w-full"
          display="chip"
          [maxSelectedLabels]="10"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('category') }"
        >
        </p-multiSelect>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Liczba punktów</div>
        <p-dropdown
          id="points"
          formControlName="points"
          [options]="pointsOptions"
          optionLabel="name"
          optionValue="value"
          placeholder="Wybierz liczbę punktów"
          appendTo="body"
          panelStyleClass="max-w-30rem"
          class="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('points') }"
        >
        </p-dropdown>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Rodzaj wiedzy</div>
        <p-dropdown
          id="knowledgeType"
          formControlName="knowledgeType"
          [options]="knowledgeTypeOptions"
          optionLabel="name"
          optionValue="value"
          placeholder="specjalistyczne"
          appendTo="body"
          panelStyleClass="max-w-30rem"
          class="w-full"
          (onChange)="onKnowledgeTypeChange($event)"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('knowledgeType') }"
        >
        </p-dropdown>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Pytanie</div>
        <input
          id="questionText"
          type="text"
          pInputText
          formControlName="questionText"
          placeholder="Droga"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('questionText') }"
        />
      </div>

      <div
        *ngIf="questionForm.get('knowledgeType')?.value === 2"
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Odpowiedź A</div>
        <input
          id="answerA"
          type="text"
          pInputText
          formControlName="answerA"
          placeholder="Odpowiedź A"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('answerA') }"
        />
      </div>

      <div
        *ngIf="questionForm.get('knowledgeType')?.value === 2"
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Odpowiedź B</div>
        <input
          id="answerB"
          type="text"
          pInputText
          formControlName="answerB"
          placeholder="Odpowiedź B"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('answerB') }"
        />
      </div>

      <div
        *ngIf="questionForm.get('knowledgeType')?.value === 2"
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Odpowiedź C</div>
        <input
          id="answerC"
          type="text"
          pInputText
          formControlName="answerC"
          placeholder="Odpowiedź C"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('answerC') }"
        />
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Prawidłowa odpowiedź</div>
        <p-dropdown
          id="correctAnswer"
          formControlName="correctAnswer"
          [options]="getCorrectAnswerOptions()"
          optionLabel="label"
          optionValue="value"
          placeholder="Wybierz odpowiedź"
          appendTo="body"
          panelStyleClass="max-w-30rem"
          class="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': isFieldInvalid('correctAnswer') }"
        >
        </p-dropdown>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center mb-6"
      >
        <div class="title">Wyjaśnienie</div>
        <textarea
          id="explainPL"
          formControlName="explainPL"
          rows="5"
          placeholder="Wyjaśnienie"
          class="default-input"
        ></textarea>
      </div>

      <div formArrayName="translations">
        <div
          *ngFor="
            let translationForm of translationsArray.controls;
            let i = index
          "
          [formGroupName]="i"
        >
          <div
            class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center"
            (click)="toggleTranslationCollapse(i)"
          >
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-flag"></i>
              <div class="font-medium">
                Wersja językowa {{ i + 1 }}<span *ngIf="translationForm.get('languageCode')?.value"> - {{ getLanguageName(translationForm.get("languageCode")?.value) }}</span>
              </div>
            </div>
            <i
              class="pi"
              [ngClass]="
                isTranslationCollapsed(i) ? 'pi-chevron-down' : 'pi-chevron-up'
              "
            ></i>
          </div>

          <div *ngIf="!isTranslationCollapsed(i)">
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Wybierz język</div>
              <p-dropdown
                [options]="getAvailableLanguagesForTranslation(i)"
                optionLabel="name"
                optionValue="code"
                placeholder="Wybierz język"
                appendTo="body"
                class="w-full"
                styleClass="w-full"
                formControlName="languageCode"
              >
              </p-dropdown>
            </div>
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Pytanie</div>
              <input
                pInputText
                formControlName="questionText"
                placeholder="Pytanie w wybranym języku"
              />
            </div>
            <div
              *ngIf="questionForm.get('knowledgeType')?.value === 2"
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Odpowiedź A</div>
              <input
                pInputText
                formControlName="answerA"
                placeholder="Odpowiedź A"
              />
            </div>
            <div
              *ngIf="questionForm.get('knowledgeType')?.value === 2"
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Odpowiedź B</div>
              <input
                pInputText
                formControlName="answerB"
                placeholder="Odpowiedź B"
              />
            </div>
            <div
              *ngIf="questionForm.get('knowledgeType')?.value === 2"
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Odpowiedź C</div>
              <input
                pInputText
                formControlName="answerC"
                placeholder="Odpowiedź C"
              />
            </div>
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Wyjaśnienie</div>
              <textarea
                pInputTextarea
                formControlName="explain"
                placeholder="Wyjaśnienie w wybranym języku"
                rows="5"
              >
              </textarea>
            </div>
            <div
              class="flex w-full justify-content-end form-decorator bottom-primary-decorator"
            >
              <p-button
                label="Usuń tą wersję językową"
                icon="pi pi-trash"
                (onClick)="removeTranslationForm(i); $event.stopPropagation()"
                data-clarity-unmask="true"
              >
              </p-button>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="canAddMoreTranslations()"
        class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center mb-3"
        (click)="addNewTranslationForm()"
      >
        <div class="add-translation">Dodaj wersje językową</div>
        <i class="add-translation pi pi-plus"></i>
      </div>
    </form>

    <div class="flex gap-3 justify-content-end pt-3">
      <p-button [link]="true" label="Anuluj" (onClick)="cancel()" data-clarity-unmask="true"></p-button>
      <p-button
        label="Dalej"
        icon="pi pi-angle-right"
        iconPos="right"
        (onClick)="nextStep()"
        [disabled]="!canProceedToNextStep()"
        data-clarity-unmask="true"
      ></p-button>
    </div>
  </div>

  <div *ngIf="currentStep === 2 && !loading">
    <div class="mb-4">
      <div
        class="form-decorator flex-column top-decorator flex w-full justify-content-start align-items-start gap-4 mt-4"
      >
        <div class="title">Plik multimedialny</div>
        <div class="flex w-full gap-2">
          <div class="w-full">
            <fas-services-upload
              [environment]="environment.webApiUrl"
              [allowedExtensions]="[
                '.png',
                '.jpg',
                '.jpeg',
                '.webp',
                '.mp4',
                '.avi',
                '.mov',
                '.wmv'
              ]"
              [mainIcon]="'pi-image'"
              [multiple]="false"
              mainMessage="Wybierz plik graficzny lub wideo z dysku lub przeciągnij tu."
              (fileSelected)="onImageSelected($event)"
              class="w-full"
            >
            </fas-services-upload>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-content-between pt-3">
      <p-button
        [link]="true"
        label="Poprzedni"
        icon="pi pi-angle-left"
        (onClick)="previousStep()"
        data-clarity-unmask="true"
      ></p-button>
      <div class="flex gap-2">
        <p-button [link]="true" label="Anuluj" (onClick)="cancel()" data-clarity-unmask="true"></p-button>
        <p-button
          label="Dodaj"
          icon="pi pi-save"
          [disabled]="!questionForm.valid"
          (onClick)="save()"
          data-clarity-unmask="true"
        ></p-button>
      </div>
    </div>
  </div>
</div>
